import React, { useState } from 'react';

import './style.css';

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import { AccessManagementpopup, ConfirmPassword } from '../..';
const Index = () => {
    return (
        <>
            <div
                style={{
                    overflowY: 'hidden',
                    overflowX: 'auto',
                    padding: '1rem',
                }}
            >
                <table className="access_management_table">
                    <thead className="access_management_table_head">
                        <tr className="access_management_table_head_row">
                            <td className="access_management_table_head_data">Name</td>
                            <td className="access_management_table_head_data">Email</td>
                            <td className="access_management_table_head_data">Allowed Access</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody className="access_management_table_body">
                        <Component
                            name="Joe Daniels"
                            accesses={['Merchants', 'Billing']}
                            email="joe@gmail.daniels.example.com"
                            id="001"
                        />
                        <Component
                            name="Joe Daniels"
                            accesses={['Merchants', 'Billing']}
                            email="joe@gmail.daniels.example.com"
                            id="002"
                        />
                        <Component
                            name="Joe Daniels"
                            accesses={['Merchants', 'Billing']}
                            email="joe@gmail.daniels.example.com"
                            id="003"
                        />
                        <Component
                            name="Joe Daniels"
                            accesses={['Merchants', 'Billing']}
                            email="joe@gmail.daniels.example.com"
                            id="004"
                        />
                        <Component
                            name="Joe Daniels"
                            accesses={['Merchants', 'Billing']}
                            email="joe@gmail.daniels.example.com"
                            id="005"
                        />
                        <Component
                            name="Joe Daniels"
                            accesses={['Merchants', 'Billing']}
                            email="joe@gmail.daniels.example.com"
                            id="006"
                        />
                    </tbody>
                </table>
            </div>
        </>
    );
};

const Component = ({ name, email, id, accesses }) => {
    const [confirmPassword, setConfirmPassword] = useState(false);
    const [showdetails, setShowdetails] = useState(false);
    return (
        <>
            <ConfirmPassword
                state={confirmPassword}
                setStateFalse={() => {
                    setConfirmPassword((prev) => !prev);
                }}
                onConfirmHandler={() => {
                    console.log(`Delete user with id: ` + id);
                }}
            />
            <AccessManagementpopup
                state={showdetails}
                setStateFalse={() => {
                    setShowdetails((prev) => !prev);
                }}
                accesses={accesses}
                name={name}
                id={id}
            />
            <tr className="access_management_table_body_row">
                <td
                    onClick={() => {
                        setShowdetails((prev) => !prev);
                    }}
                    className="access_management_table_body_data"
                >
                    {name}
                </td>
                <td
                    onClick={() => {
                        setShowdetails((prev) => !prev);
                    }}
                    className="access_management_table_body_data"
                >
                    {email}
                </td>
                <td
                    onClick={() => {
                        setShowdetails((prev) => !prev);
                    }}
                    className="access_management_table_body_data"
                >
                    {accesses.reduce((prev, curr, i) => {
                        if (i === 0) {
                            return prev + '' + curr;
                        }
                        return prev + ', ' + curr;
                    }, '')}
                </td>
                <td className="access_management_table_body_data">
                    <div className="access_management_icons">
                        <DeleteForeverIcon
                            onClick={() => {
                                setConfirmPassword((prev) => !prev);
                            }}
                            className="access_management_icon"
                        />
                    </div>
                </td>
            </tr>
        </>
    );
};

export default Index;
